import React, { useMemo } from 'react';

import Content from './content';
import { useCreateReturnContext } from '../../../context/create-return-provider';

const EditableContainer = () => {
  const { shipTo, recipientInfo } = useCreateReturnContext();
  const returnShipmentDetails = useMemo(() => {
    return {
      shipTo,
      recipientInfo,
    };
  }, [shipTo, recipientInfo]);

  return <Content returnShipmentDetails={returnShipmentDetails} />;
};

export default EditableContainer;
